var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "items-list--item" },
    [
      _c(
        "b-row",
        { attrs: { "align-v": "center" } },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("div", { staticClass: "items-list--item-label" }, [
              _vm._v("Datum")
            ]),
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm._f("dateTime")(_vm.transaction.timeStamp)) +
                "\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c("div", { staticClass: "items-list--item-label" }, [
                _vm._v("Produkt")
              ]),
              _vm._v(" "),
              _vm._l(_vm.transaction.items, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "item-list--item-product" },
                  [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(item.product.label) + "\n\t\t\t"
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "1" } }, [
            _c("div", { staticClass: "items-list--item-label" }, [
              _vm._v("Betrag")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "items-list--item-amount" }, [
              _vm.transaction.type.token
                ? _c("span", [
                    _vm._v(_vm._s(_vm.transaction.tokenAmount) + " Token")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.transaction.type.fiat
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("moneyAmount")(
                          _vm.transaction.totalGrossAmountFormatted
                        )
                      )
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "2" } }, [
            _c("div", { staticClass: "items-list--item-actions" }, [
              _vm.transaction.invoice
                ? _c(
                    "a",
                    {
                      directives: [
                        { name: "b-tooltip", rawName: "v-b-tooltip" }
                      ],
                      attrs: {
                        href:
                          "/transaktion/" + _vm.transaction.id + "/rechnung",
                        title: "Rechnung (PDF)",
                        target: "_blank"
                      }
                    },
                    [_c("Icon", { attrs: { icon: "invoice" } })],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }